/*
 * AQUORIX shared nationality reference data.
 *
 * This is the frontend fallback for GET /api/v1/nationalities.
 * Runtime API data remains preferred. The clerk picks a country; the ISO alpha-2
 * code is what is stored. Authority-specific export labels belong in authority
 * mapping data, not page logic.
 */

export type Nationality = { c: string; n: string };

export const NATIONALITIES: Nationality[] = [
  {c:"AF",n:"Afghanistan"},
  {c:"AL",n:"Albania"},
  {c:"DZ",n:"Algeria"},
  {c:"AS",n:"American Samoa"},
  {c:"AD",n:"Andorra"},
  {c:"AO",n:"Angola"},
  {c:"AI",n:"Anguilla"},
  {c:"AQ",n:"Antarctica"},
  {c:"AG",n:"Antigua and Barbuda"},
  {c:"AR",n:"Argentina"},
  {c:"AM",n:"Armenia"},
  {c:"AW",n:"Aruba"},
  {c:"AU",n:"Australia"},
  {c:"AT",n:"Austria"},
  {c:"AZ",n:"Azerbaijan"},
  {c:"BS",n:"Bahamas"},
  {c:"BH",n:"Bahrain"},
  {c:"BD",n:"Bangladesh"},
  {c:"BB",n:"Barbados"},
  {c:"BY",n:"Belarus"},
  {c:"BE",n:"Belgium"},
  {c:"BZ",n:"Belize"},
  {c:"BJ",n:"Benin"},
  {c:"BM",n:"Bermuda"},
  {c:"BT",n:"Bhutan"},
  {c:"BO",n:"Bolivia"},
  {c:"BQ",n:"Bonaire, Sint Eustatius and Saba"},
  {c:"BA",n:"Bosnia and Herzegovina"},
  {c:"BW",n:"Botswana"},
  {c:"BV",n:"Bouvet Island"},
  {c:"BR",n:"Brazil"},
  {c:"IO",n:"British Indian Ocean Territory"},
  {c:"BN",n:"Brunei Darussalam"},
  {c:"BG",n:"Bulgaria"},
  {c:"BF",n:"Burkina Faso"},
  {c:"BI",n:"Burundi"},
  {c:"CV",n:"Cabo Verde"},
  {c:"KH",n:"Cambodia"},
  {c:"CM",n:"Cameroon"},
  {c:"CA",n:"Canada"},
  {c:"KY",n:"Cayman Islands"},
  {c:"CF",n:"Central African Republic"},
  {c:"TD",n:"Chad"},
  {c:"CL",n:"Chile"},
  {c:"CN",n:"China"},
  {c:"CX",n:"Christmas Island"},
  {c:"CC",n:"Cocos (Keeling) Islands"},
  {c:"CO",n:"Colombia"},
  {c:"KM",n:"Comoros"},
  {c:"CG",n:"Congo"},
  {c:"CD",n:"Congo, The Democratic Republic of the"},
  {c:"CK",n:"Cook Islands"},
  {c:"CR",n:"Costa Rica"},
  {c:"HR",n:"Croatia"},
  {c:"CU",n:"Cuba"},
  {c:"CW",n:"Curaçao"},
  {c:"CY",n:"Cyprus"},
  {c:"CZ",n:"Czechia"},
  {c:"CI",n:"Côte d'Ivoire"},
  {c:"DK",n:"Denmark"},
  {c:"DJ",n:"Djibouti"},
  {c:"DM",n:"Dominica"},
  {c:"DO",n:"Dominican Republic"},
  {c:"EC",n:"Ecuador"},
  {c:"EG",n:"Egypt"},
  {c:"SV",n:"El Salvador"},
  {c:"GQ",n:"Equatorial Guinea"},
  {c:"ER",n:"Eritrea"},
  {c:"EE",n:"Estonia"},
  {c:"SZ",n:"Eswatini"},
  {c:"ET",n:"Ethiopia"},
  {c:"FK",n:"Falkland Islands (Malvinas)"},
  {c:"FO",n:"Faroe Islands"},
  {c:"FJ",n:"Fiji"},
  {c:"FI",n:"Finland"},
  {c:"FR",n:"France"},
  {c:"GF",n:"French Guiana"},
  {c:"PF",n:"French Polynesia"},
  {c:"TF",n:"French Southern Territories"},
  {c:"GA",n:"Gabon"},
  {c:"GM",n:"Gambia"},
  {c:"GE",n:"Georgia"},
  {c:"DE",n:"Germany"},
  {c:"GH",n:"Ghana"},
  {c:"GI",n:"Gibraltar"},
  {c:"GR",n:"Greece"},
  {c:"GL",n:"Greenland"},
  {c:"GD",n:"Grenada"},
  {c:"GP",n:"Guadeloupe"},
  {c:"GU",n:"Guam"},
  {c:"GT",n:"Guatemala"},
  {c:"GG",n:"Guernsey"},
  {c:"GN",n:"Guinea"},
  {c:"GW",n:"Guinea-Bissau"},
  {c:"GY",n:"Guyana"},
  {c:"HT",n:"Haiti"},
  {c:"HM",n:"Heard Island and McDonald Islands"},
  {c:"VA",n:"Holy See (Vatican City State)"},
  {c:"HN",n:"Honduras"},
  {c:"HK",n:"Hong Kong"},
  {c:"HU",n:"Hungary"},
  {c:"IS",n:"Iceland"},
  {c:"IN",n:"India"},
  {c:"ID",n:"Indonesia"},
  {c:"IR",n:"Iran"},
  {c:"IQ",n:"Iraq"},
  {c:"IE",n:"Ireland"},
  {c:"IM",n:"Isle of Man"},
  {c:"IL",n:"Israel"},
  {c:"IT",n:"Italy"},
  {c:"JM",n:"Jamaica"},
  {c:"JP",n:"Japan"},
  {c:"JE",n:"Jersey"},
  {c:"JO",n:"Jordan"},
  {c:"KZ",n:"Kazakhstan"},
  {c:"KE",n:"Kenya"},
  {c:"KI",n:"Kiribati"},
  {c:"KW",n:"Kuwait"},
  {c:"KG",n:"Kyrgyzstan"},
  {c:"LA",n:"Laos"},
  {c:"LV",n:"Latvia"},
  {c:"LB",n:"Lebanon"},
  {c:"LS",n:"Lesotho"},
  {c:"LR",n:"Liberia"},
  {c:"LY",n:"Libya"},
  {c:"LI",n:"Liechtenstein"},
  {c:"LT",n:"Lithuania"},
  {c:"LU",n:"Luxembourg"},
  {c:"MO",n:"Macao"},
  {c:"MG",n:"Madagascar"},
  {c:"MW",n:"Malawi"},
  {c:"MY",n:"Malaysia"},
  {c:"MV",n:"Maldives"},
  {c:"ML",n:"Mali"},
  {c:"MT",n:"Malta"},
  {c:"MH",n:"Marshall Islands"},
  {c:"MQ",n:"Martinique"},
  {c:"MR",n:"Mauritania"},
  {c:"MU",n:"Mauritius"},
  {c:"YT",n:"Mayotte"},
  {c:"MX",n:"Mexico"},
  {c:"FM",n:"Micronesia, Federated States of"},
  {c:"MD",n:"Moldova"},
  {c:"MC",n:"Monaco"},
  {c:"MN",n:"Mongolia"},
  {c:"ME",n:"Montenegro"},
  {c:"MS",n:"Montserrat"},
  {c:"MA",n:"Morocco"},
  {c:"MZ",n:"Mozambique"},
  {c:"MM",n:"Myanmar"},
  {c:"NA",n:"Namibia"},
  {c:"NR",n:"Nauru"},
  {c:"NP",n:"Nepal"},
  {c:"NL",n:"Netherlands"},
  {c:"NC",n:"New Caledonia"},
  {c:"NZ",n:"New Zealand"},
  {c:"NI",n:"Nicaragua"},
  {c:"NE",n:"Niger"},
  {c:"NG",n:"Nigeria"},
  {c:"NU",n:"Niue"},
  {c:"NF",n:"Norfolk Island"},
  {c:"KP",n:"North Korea"},
  {c:"MK",n:"North Macedonia"},
  {c:"MP",n:"Northern Mariana Islands"},
  {c:"NO",n:"Norway"},
  {c:"OM",n:"Oman"},
  {c:"PK",n:"Pakistan"},
  {c:"PW",n:"Palau"},
  {c:"PS",n:"Palestine, State of"},
  {c:"PA",n:"Panama"},
  {c:"PG",n:"Papua New Guinea"},
  {c:"PY",n:"Paraguay"},
  {c:"PE",n:"Peru"},
  {c:"PH",n:"Philippines"},
  {c:"PN",n:"Pitcairn"},
  {c:"PL",n:"Poland"},
  {c:"PT",n:"Portugal"},
  {c:"PR",n:"Puerto Rico"},
  {c:"QA",n:"Qatar"},
  {c:"RO",n:"Romania"},
  {c:"RU",n:"Russian Federation"},
  {c:"RW",n:"Rwanda"},
  {c:"RE",n:"Réunion"},
  {c:"BL",n:"Saint Barthélemy"},
  {c:"SH",n:"Saint Helena, Ascension and Tristan da Cunha"},
  {c:"KN",n:"Saint Kitts and Nevis"},
  {c:"LC",n:"Saint Lucia"},
  {c:"MF",n:"Saint Martin (French part)"},
  {c:"PM",n:"Saint Pierre and Miquelon"},
  {c:"VC",n:"Saint Vincent and the Grenadines"},
  {c:"WS",n:"Samoa"},
  {c:"SM",n:"San Marino"},
  {c:"ST",n:"Sao Tome and Principe"},
  {c:"SA",n:"Saudi Arabia"},
  {c:"SN",n:"Senegal"},
  {c:"RS",n:"Serbia"},
  {c:"SC",n:"Seychelles"},
  {c:"SL",n:"Sierra Leone"},
  {c:"SG",n:"Singapore"},
  {c:"SX",n:"Sint Maarten (Dutch part)"},
  {c:"SK",n:"Slovakia"},
  {c:"SI",n:"Slovenia"},
  {c:"SB",n:"Solomon Islands"},
  {c:"SO",n:"Somalia"},
  {c:"ZA",n:"South Africa"},
  {c:"GS",n:"South Georgia and the South Sandwich Islands"},
  {c:"KR",n:"South Korea"},
  {c:"SS",n:"South Sudan"},
  {c:"ES",n:"Spain"},
  {c:"LK",n:"Sri Lanka"},
  {c:"SD",n:"Sudan"},
  {c:"SR",n:"Suriname"},
  {c:"SJ",n:"Svalbard and Jan Mayen"},
  {c:"SE",n:"Sweden"},
  {c:"CH",n:"Switzerland"},
  {c:"SY",n:"Syria"},
  {c:"TW",n:"Taiwan"},
  {c:"TJ",n:"Tajikistan"},
  {c:"TZ",n:"Tanzania"},
  {c:"TH",n:"Thailand"},
  {c:"TL",n:"Timor-Leste"},
  {c:"TG",n:"Togo"},
  {c:"TK",n:"Tokelau"},
  {c:"TO",n:"Tonga"},
  {c:"TT",n:"Trinidad and Tobago"},
  {c:"TN",n:"Tunisia"},
  {c:"TM",n:"Turkmenistan"},
  {c:"TC",n:"Turks and Caicos Islands"},
  {c:"TV",n:"Tuvalu"},
  {c:"TR",n:"Türkiye"},
  {c:"UG",n:"Uganda"},
  {c:"UA",n:"Ukraine"},
  {c:"AE",n:"United Arab Emirates"},
  {c:"GB",n:"United Kingdom"},
  {c:"US",n:"United States"},
  {c:"UM",n:"United States Minor Outlying Islands"},
  {c:"UY",n:"Uruguay"},
  {c:"UZ",n:"Uzbekistan"},
  {c:"VU",n:"Vanuatu"},
  {c:"VE",n:"Venezuela"},
  {c:"VN",n:"Vietnam"},
  {c:"VG",n:"Virgin Islands, British"},
  {c:"VI",n:"Virgin Islands, U.S."},
  {c:"WF",n:"Wallis and Futuna"},
  {c:"EH",n:"Western Sahara"},
  {c:"YE",n:"Yemen"},
  {c:"ZM",n:"Zambia"},
  {c:"ZW",n:"Zimbabwe"},
  {c:"AX",n:"Åland Islands"}
];

export function nationalityLabel(code: string, nationalities: Nationality[] = NATIONALITIES): string {
  const hit = nationalities.find((item) => item.c === code);
  return hit ? hit.n : "";
}
